import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import * as entity from '@boutique/entities'

type FutureProps = {
  brand: entity.brand.Brand
  dangerouslySetInnerHTML: { __html: string }
}

export function FutureCommitments({ brand, dangerouslySetInnerHTML }: FutureProps) {
  return (
    <Wrapper>
      <ds.styles.heading.Title3>Engagements futurs</ds.styles.heading.Title3>
      <ds.styles.copy.Text1>
        En tant que signataire de la charte Bien ou Bien, {brand.name} est dans un processus d'amélioration continue :
      </ds.styles.copy.Text1>
      <ds.styles.wysiwyg.MarkdownBlockQuote>
        <ds.styles.wysiwyg.MarkdownBlockQuoteContent dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
      </ds.styles.wysiwyg.MarkdownBlockQuote>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${ds.styles.heading.Title3} {
    margin-bottom: 14px;
  }

  ${ds.styles.wysiwyg.MarkdownBlockQuote} {
    margin-top: 24px;
    margin-bottom: 60px;
  }
`
